export const defaultFilters = () => ({
  pagination: {
    limit: 20,
    page: 1,
  },
  filter: {
    partners: null,
    trafficSource: null,
    country: null,
    streams: null,
    partnerEventGroup: null,
    additionalEventGroups: null,
    advertiser: null,
    product: null,
    paymentModel: null,
    landings: null,
  },
  sortBy: ['id'],
  sortDesc: [true],
  clientOptions: {
    filterPanelExpanded: true,
  },
})

export const EXCLUDABLE_FILTERS = ['countries', 'streams', 'additionalEventGroups', 'landings']